import type { ReactNode } from 'react';

export type FigureTone = 'default' | 'emphasis' | 'muted';

const LABEL_CLASS: Record<FigureTone, string> = {
    default: 'text-mp-muted',
    emphasis: 'font-semibold text-mp-foreground',
    muted: 'text-mp-muted',
};

const VALUE_CLASS: Record<FigureTone, string> = {
    default: 'font-medium text-mp-foreground',
    emphasis: 'font-semibold text-mp-foreground',
    muted: 'text-mp-muted',
};

export function FigureList({ children }: { children: ReactNode }) {
    return <dl className="space-y-1 text-sm">{children}</dl>;
}

export function FigureRow({ label, value, tone = 'default' }: { label: ReactNode; value: ReactNode; tone?: FigureTone }) {
    return (
        <div className="grid grid-cols-[1fr_auto] gap-4">
            <dt className={LABEL_CLASS[tone]}>{label}</dt>
            <dd className={VALUE_CLASS[tone]}>{value}</dd>
        </div>
    );
}
